// Mock data for Selekto Sähköpalvelu — modern redesign
// NOTE: This data is currently MOCKED on the frontend. Backend integration can replace it later.

import {
  Flame,
  Cable,
  Activity,
  Gauge,
  Lightbulb,
  BatteryCharging,
  Zap,
  ClipboardCheck,
  FileStack,
} from "lucide-react";

export const company = {
  name: "SELEKTO",
  tagline: "Sähköpalvelu",
  slogan: "Sähköisen tilan ylläpito",
  founded: 2011,
  anniversary: "15 vuotta · 1.3.2026",
  region: "Seinäjoki ja ympäristökunnat",
  phone: "0400 628 447",
  phoneRaw: "+358400628447",
  email: "tuomo.ojala@selekto.fi",
  facebook: "https://www.facebook.com/selekto.fi/?locale=fi_FI",
  ytunnus: "2381107-6",
  address: "Lastausväylä 2B, 60100 Seinäjoki",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=Lastausv%C3%A4yl%C3%A4+2B+60100+Sein%C3%A4joki",
  contactPerson: {
    name: "Tuomo Ojala",
    title: "Sähkötöidenjohtaja · Director of Electrical Work",
  },
};

export const navLinks = [
  { label: "Etusivu", type: "route", to: "/" },
  { label: "Palvelut", type: "route", to: "/palvelut" },
  { label: "Yritys", type: "hash", id: "yritys" },
  { label: "Uutiset", type: "hash", id: "uutiset" },
  { label: "Yhteystiedot", type: "hash", id: "yhteystiedot" },
];

export const heroStats = [
  { value: "15v", label: "Kokemusta alalta" },
  { value: "SETI LK1", label: "Lämpökuvaajayritys" },
];

export const services = [
  {
    id: "kaytonjohtaja",
    icon: ClipboardCheck,
    title: "Käytönjohtajapalvelut",
    short: "Alle ja yli 1 kV · 20 kV muuntamot",
    description:
      "Käytönjohtajapalvelut keskijänniteliittymille (luokka 2c) ja yli 1600 kVA pienjänniteliittymille (luokka 2d). Vastaamme laitteiston turvallisuudesta.",
    tag: "Vastuu",
    href: "/asiakkaat",
  },
  {
    id: "sahkoasemat",
    icon: Zap,
    title: "Sähköasemat ja erotinasemat",
    short: "20 kV järjestelmät",
    description:
      "Käytännön kokemusta 20 kV sähköasematöissä sekä erotinasemilla. Tuntemus sähkönjakelusta ja verkon rakenteesta.",
    tag: "Asennus",
  },
  {
    id: "lampokuvaus",
    icon: Flame,
    title: "Lämpökuvaus sähkölaitteille",
    short: "SETI LK1 -lämpökuvaajayritys",
    description:
      "Sertifioitu lämpökuvaus sähkölaitteistoille ja -keskuksille. Ennakoiva kunnossapito paljastaa ylikuormitukset ja vialliset liitokset ennen vahinkoja.",
    tag: "SETI LK1",
  },
  {
    id: "maadoitus",
    icon: Cable,
    title: "Maadoitus- ja jatkuvuusmittaukset",
    short: "Tuulivoimalat & ukkossuojaus",
    description:
      "Maadoitusmittaukset tuulivoimaloille ja kirkkorakennusten ukkossuojaukselle (velvoite 5 vuoden välein). Grounding measurement of wind turbines.",
    tag: "Mittaus",
  },
  {
    id: "laatumittaus",
    icon: Activity,
    title: "Kuormitus- ja sähkön laatumittaukset",
    short: "Häiriöselvitykset",
    description:
      "Sähköverkon kuormitus- ja laatumittaukset sekä häiriöiden selvitys. Tunnistamme ongelmat ja tuotamme selkeät raportit toimenpiteitä varten.",
    tag: "Mittaus",
  },
  {
    id: "kompensointi",
    icon: Gauge,
    title: "Loistehon kompensointi",
    short: "Tarkistuta – säästä!",
    description:
      "Loistehon kompensoinnin mittaukset ja optimointi. Oikein mitoitettu kompensointi pienentää sähkölaskua ja parantaa verkon laatua.",
    tag: "Säästö",
  },
  {
    id: "turvavalo",
    icon: Lightbulb,
    title: "Turvavalokeskus- ja valaistushuollot",
    short: "Ylläpitohuollot",
    description:
      "Turvavalokeskusten ja valaistusjärjestelmien ylläpitohuollot. Varmistamme, että turvavalaistus toimii määräysten mukaisesti.",
    tag: "Huolto",
  },
  {
    id: "ups",
    icon: BatteryCharging,
    title: "Tasasähköjärjestelmät, UPS & akustot",
    short: "UPS, akustot ja varaajat",
    description:
      "Tasasähköjärjestelmien, UPS-laitteiden, akustojen ja varaajien asennus, huolto ja osavaihdot varmatoimisen sähkönsyötön turvaamiseksi.",
    tag: "Huolto",
  },
  {
    id: "sahkokuvat",
    icon: FileStack,
    title: "Sähkökuvapäivitykset",
    short: "Paperikuvat → CAD",
    description:
      "Vanhojen paperikuvien kartoitus ja päivitys nykyaikaisiksi CAD-sähkökuviksi. Muutosten dokumentointi ja uusien kuvien tulostus.",
    tag: "Dokumentointi",
  },
];

export const news = [
  {
    id: 1,
    date: "12.6.2025",
    category: "Ajankohtaista",
    title: "Kesäkauden lämpökuvaukset käynnissä",
    excerpt:
      "Varaa sähkölaitteistosi lämpökuvaus hyvissä ajoin. Ennakoiva kunnossapito säästää yllätyskustannuksilta talven kuormitushuippuja ajatellen.",
  },
  {
    id: 2,
    date: "3.4.2025",
    category: "Määräykset",
    title: "Kirkkojen ukkossuojauksen mittaukset",
    excerpt:
      "Muistathan, että kirkkorakennusten ukkossuojauksen maadoitusmittaukset on tehtävä viiden vuoden välein. Hoidamme mittaukset ja raportoinnin.",
  },
  {
    id: 3,
    date: "18.1.2025",
    category: "Palvelut",
    title: "Loistehon kompensointi – tarkistuta ja säästä",
    excerpt:
      "Oikein mitoitettu loistehon kompensointi pienentää sähkölaskua merkittävästi. Teemme mittaukset ja laskemme takaisinmaksuajan.",
  },
];

export const products = [
  {
    id: 1,
    name: "Lämpökamerakuvaus",
    desc: "Ammattitason IR-kuvaus keskuksille ja liitoksille raportteineen.",
  },
  {
    id: 2,
    name: "Maadoitusmittarit",
    desc: "Tarkat maadoitus- ja jatkuvuusmittaukset kohteen tarpeen mukaan.",
  },
  {
    id: 3,
    name: "Sähkön laatuanalysaattorit",
    desc: "Kuormitus- ja laatumittaukset pitkäaikaisseurannalla.",
  },
  {
    id: 4,
    name: "Kompensointiratkaisut",
    desc: "Loistehon kompensoinnin mitoitus ja toteutus.",
  },
];

export const links = [
  { label: "Tukes – Turvallisuus- ja kemikaalivirasto", url: "https://tukes.fi" },
  { label: "SETI Oy – Sertifiointi", url: "https://seti.fi" },
  { label: "Sähkö- ja teleurakoitsijaliitto STUL", url: "https://stul.fi" },
  { label: "Fingrid – Kantaverkkoyhtiö", url: "https://fingrid.fi" },
];

// Käytönjohtaja customers — Selekto toimii sähköjärjestelmän käytönjohtajana
export const customers = [
  { name: "MSK Cabins Oy ja Junkkari Oy", location: "Ylihärmä" },
  { name: "MSK Plast 1, 2, 3 Oy", location: "Ylihärmä" },
  { name: "Skaala IFN Oy", location: "Ylihärmä" },
  { name: "Skaala IFN Oy", location: "Karvia" },
  { name: "Härmän Kuntokeskus", location: "Ylihärmä" },
  { name: "INTO Oy", detail: "ABCD-osa", location: "Seinäjoki" },
  { name: "FRAMI Oy", detail: "EF-osa", location: "Seinäjoki" },
  { name: "Rytmikorjaamo Oy", location: "Seinäjoki" },
  { name: "Nurmon Aurinko Oy", detail: "Aurinkovoimala K1, Atria", location: "Nurmo" },
  { name: "Nurmon Aurinko Oy", detail: "Aurinkovoimala K2, Atria", location: "Nurmo" },
  { name: "Nurmon Aurinko Oy", detail: "Aurinkovoimala K12, Atria", location: "Nurmo" },
  { name: "Lakeuden Etappi Oy", detail: "Jätehuoltokeskus", location: "Ilmajoki" },
  { name: "Lakeuden Etappi Oy", detail: "Biojätelaitos", location: "Ilmajoki" },
  { name: "Sandvik Mining and Construction Oy", location: "Tampere" },
  { name: "HVA-Kiinteistö Varastotie", location: "Seinäjoki" },
  {
    name: "Kiinteistö Oy Seinäjoen Terveysteknologiakeskus",
    detail: "M-talo",
    location: "Seinäjoki",
  },
  { name: "Seinäjoen koulutuskuntayhtymä SEDU", location: "Seinäjoki" },
  { name: "Atria Lämpö Sähkökattila", detail: "Nevel Oy", location: "Nurmo" },
];

